export enum AvailableFileTypes {
  ICO = 'ico',
  PDF = 'pdf',
  DOC = 'doc',
  DOCX = 'docx'
}
